import { Toast } from 'bootstrap';
import EstateFormValidation from '@/js/components/forms/estateFormValidation';
import Dropzone from '@/js/components/dropzone';

class AccountEstateEdit {
  constructor() {
    this.dom = {
      formEstate: document.getElementById('form-estate'),
      selectLanguage: document.getElementById('estate-texts-languages'),
      dropzoneEl: document.getElementById('estate-photos-dropzone'),
      toastMaxExceedError: document.getElementById('toast-max-exceeded-error'),
      toastFileDisallowed: document.getElementById('toast-file-disallowed'),
      textAreas: document.getElementsByClassName('auto-size'),

      estateTypeSelect: document.getElementById('estate-properties-type'),
      estateBuildYearTypeSelect: document.getElementById('estate-properties-build-year-type'),
      estateRenovatedNewConstructionCheckbox: document.getElementById('estate-properties-renovated-new-construction'),
      estateNewConstructionFullVatCheckbox: document.getElementById('estate-properties-new-construction-full-vat'),
    };

    this.components = {
      estateFormValidation: null,
    };
  }

  mount() {
    if (this.dom.formEstate) {
      this.components.estateFormValidation = new EstateFormValidation(this.dom.formEstate);
    }

    this.checkScrollHeights();

    this.dom.selectLanguage.addEventListener('change', (e) => {
      document.querySelectorAll('.collapse-language.show')[0].classList.remove('show');
      document.getElementById(`estate-texts-${e.currentTarget.value}`).classList.add('show');
      this.checkScrollHeights();
    });

    this.dom.estateTypeSelect.addEventListener('change', () => {
      const estateBuildYearTypeSelectContainer = this.dom.estateBuildYearTypeSelect.parentElement.parentElement;
      const estateRenovatedNewConstructionCheckboxContainer = this.dom.estateRenovatedNewConstructionCheckbox.parentElement.parentElement;
      const estateNewConstructionFullVatCheckboxContainer = this.dom.estateNewConstructionFullVatCheckbox.parentElement.parentElement;

      // When we have the correct value we show the select
      if (parseInt(this.dom.estateTypeSelect.value, 10) === 9) {
        estateBuildYearTypeSelectContainer.classList.remove('d-none');
        this.dom.estateBuildYearTypeSelect.disabled = false;

        estateRenovatedNewConstructionCheckboxContainer.classList.add('d-none');
        estateNewConstructionFullVatCheckboxContainer.classList.add('d-none');
        this.dom.estateRenovatedNewConstructionCheckbox.disabled = true;
      } else {
        estateBuildYearTypeSelectContainer.classList.add('d-none');
        this.dom.estateBuildYearTypeSelect.disabled = true;

        estateRenovatedNewConstructionCheckboxContainer.classList.remove('d-none');
        estateNewConstructionFullVatCheckboxContainer.classList.remove('d-none');
        this.dom.estateRenovatedNewConstructionCheckbox.disabled = false;
      }
    });

    // Both checkboxes can't be used at the same time, but we don't want radio's as they are both also optional values
    this.dom.estateRenovatedNewConstructionCheckbox.addEventListener('change', () => {
      if (this.dom.estateRenovatedNewConstructionCheckbox.checked && this.dom.estateNewConstructionFullVatCheckbox.checked) {
        this.dom.estateNewConstructionFullVatCheckbox.checked = false;
      }
    });
    this.dom.estateNewConstructionFullVatCheckbox.addEventListener('change', () => {
      if (this.dom.estateNewConstructionFullVatCheckbox.checked && this.dom.estateNewConstructionFullVatCheckbox.checked) {
        this.dom.estateRenovatedNewConstructionCheckbox.checked = false;
      }
    });

    if (this.dom.dropzoneEl) {
      this.components.dropzone = new Dropzone({ container: this.dom.dropzoneEl, url: window.location.href });
      // Catch the errors of the dropzone
      this.components.dropzone.components.dropzone.on('error', (file, response) => {
        // Show toast notifications
        if (this.dom.toastFileDisallowed && response === this.components.dropzone.data.options.dictInvalidFileType) {
          Toast.getOrCreateInstance(this.dom.toastFileDisallowed).show();
        }

        // Process the error as an alert
        this.components.estateFormValidation.components.fieldsets.forEach((fieldset) => {
          if (fieldset.dom.fieldsetEl.name === 'Photos') {
            // Add the error message to the photos fieldset
            fieldset.setInvalid(Object.values(response?.errors ?? {}).join(', '));
          }
        });
      });

      if (this.dom.toastMaxExceedError) {
        this.components.dropzone.components.dropzone.on('maxfilesexceeded', () => {
          Toast.getOrCreateInstance(this.dom.toastMaxExceedError).show();
        });
      }
    }
  }

  checkScrollHeights() {
    Array.prototype.forEach.call(this.dom.textAreas, (el) => {
      if (el.scrollHeight > el.style.minHeight) {
        document.getElementById(el.id).style.height = `${el.scrollHeight + 10}px`;
      }
    });
  }
}

if (document.getElementById('page-account-estate-edit')) {
  new AccountEstateEdit().mount();
}
